// extracted by mini-css-extract-plugin
export default {"dynamicLpContainer":"DynamicLandingPageContainer_dynamicLpContainer__IDz1t","pageWidth":"DynamicLandingPageContainer_pageWidth__pG5Kn"};